module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/desktop/dashkit-alt-dark-e5edd45f75ed1b333ad056c95026f8c7.jpg";